export const getImageDimensions = (
    file: File
): Promise<{ width: number; height: number }> =>
    new Promise((resolve, reject) => {
        const image = new Image();
        const url = URL.createObjectURL(file);

        image.onload = () => {
            resolve({ width: image.width, height: image.height });
            URL.revokeObjectURL(url);
        };

        image.onerror = () => {
            URL.revokeObjectURL(url);
            reject(new Error('Invalid image'));
        };

        image.src = url;
    });

export const EMPTY_FILE_STATE = {
    Caption: '',
    VirtualPath: '',
};

export const adaptFileState = (
    file: { Caption?: string; VirtualPath?: string } | undefined,
    id: number
) =>
    id > 0
        ? {
              Caption: file?.Caption || '',
              VirtualPath: file?.VirtualPath || '',
          }
        : EMPTY_FILE_STATE;
